import {Injectable} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";

@Injectable()
export class InstallationDialogService {
  constructor(
    private dialogService: DialogService,
  ) {
  }
}
